export default "__VITE_ASSET__DKpE0FBu__"